import {DodgerBlueColor} from '../../cmsMainStyle'

const fullScreenDialogStyle = theme => ({
	root: {
		'& > *': {
			margin: theme.spacing(1),
		},
	},

	appBar: {
		position: "relative",
		backgroundColor: DodgerBlueColor[11],
	},

	title: {
		flex: 1,
		marginLeft: theme.spacing(2),
		
	},

	content: {
		paddingTop: theme.spacing(0.5),
		paddingLeft: theme.spacing(1),
		paddingRight: theme.spacing(1)
	}
})


export {fullScreenDialogStyle}